import * as React from 'react';

const Whatsapp = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <g clipPath="url(#whatsapp_a)">
            <path
                fill="#fff"
                d="m0 24 1.695-6.16a11.8 11.8 0 0 1-1.594-5.947C.1 5.333 5.464.001 12.05.001c1.569 0 3.123.308 4.573.906a12 12 0 0 1 3.878 2.58 11.855 11.855 0 0 1 3.5 8.415c-.004 6.56-5.365 11.892-11.952 11.892h-.007c-1.994 0-3.958-.498-5.71-1.448zm6.629-3.807.362.215a9.96 9.96 0 0 0 5.055 1.378h.004c5.475 0 9.93-4.435 9.933-9.885a9.87 9.87 0 0 0-2.907-6.993 9.96 9.96 0 0 0-7.022-2.899c-5.478 0-9.933 4.434-9.936 9.884a9.8 9.8 0 0 0 1.519 5.26l.236.374-1.004 3.65z"
            />
            <path
                fill="#20B038"
                d="m.416 23.587 1.636-5.95a11.4 11.4 0 0 1-1.54-5.744C.515 5.562 5.69.413 12.05.413c1.515 0 3.016.298 4.416.876a11.5 11.5 0 0 1 3.743 2.49 11.5 11.5 0 0 1 2.5 3.729c.58 1.394.877 2.888.877 4.397 0 6.331-5.178 11.48-11.536 11.48h-.005c-1.926 0-3.821-.48-5.513-1.396z"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M9.064 6.92c-.223-.494-.458-.504-.671-.513C8.22 6.4 8.019 6.4 7.82 6.4a1.1 1.1 0 0 0-.796.372c-.274.298-1.046 1.017-1.046 2.48 0 1.462 1.07 2.875 1.22 3.074.148.198 2.065 3.295 5.099 4.486 2.52.99 3.036.794 3.583.742s1.766-.72 2.015-1.413c.249-.695.25-1.289.172-1.413-.077-.125-.273-.199-.573-.347-.3-.149-1.766-.868-2.04-.967-.273-.099-.473-.149-.672.149s-.77.966-.945 1.165c-.174.198-.348.223-.647.074-.298-.149-1.26-.462-2.401-1.475-.888-.788-1.487-1.76-1.662-2.058s-.018-.457.131-.607c.134-.133.299-.347.448-.52s.2-.298.298-.496c.1-.198.05-.372-.024-.52-.075-.15-.65-1.618-.916-2.205"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="whatsapp_a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default Whatsapp;
